import { FormTextField } from '@orbis-systems/orbis-react-toolkit';
import { FormikProps } from 'formik';
import React from 'react';

import { Grid, Typography } from '@mui/material';

import Form from '@components/forms';
import { BackSubmitButton } from '@components/forms/currentUser/styles';
import Loader from '@components/loader';
import SubmitButton from '@components/submitButton';

import { AuthAppTOTPFormValues } from '@pages/Verification/MFASetupPage/components/EnableTOTP2FA/hooks/useAuthAppTOTPForm';

const TOTPForm = <T extends Omit<AuthAppTOTPFormValues, 'name'>>({
	initialStringCode,
	isInitialLoading,
	initialQrCode,
	title = 'TOTP',
	onDecline,
	formik,
}: {
	initialStringCode?: string;
	isInitialLoading?: boolean;
	formik: FormikProps<T>;
	initialQrCode?: string;
	onDecline?: () => void;
	title?: string;
}) => {
	return (
		<Form formik={formik}>
			<Grid container spacing={3}>
				<Grid item>
					<Typography variant={'subtitle1'} sx={{ fontSize: 18 }}>
						{title}
					</Typography>
				</Grid>
				{((initialQrCode && initialStringCode) || isInitialLoading) && (
					<Grid item container spacing={1}>
						<Grid item container sx={{ width: 256, height: 256 }} alignItems={'center'} justifyContent={'center'}>
							{isInitialLoading ? <Loader /> : <img src={initialQrCode} alt={'qr'} />}
						</Grid>
						<Grid item mt={3}>
							<Typography variant={'body1'}>Scan this code with Google Authentication app</Typography>
						</Grid>
						<Grid item mt={1}>
							<Typography variant={'body1'}>Or enter this code into your authentication app</Typography>
						</Grid>
						<Grid item mt={1}>
							<Typography variant={'subtitle1'} sx={{ fontSize: 20 }}>
								<b>{initialStringCode?.match(/.{1,4}/g)?.join(' ')}</b>
							</Typography>
						</Grid>
					</Grid>
				)}
				<Grid item xs={12}>
					<FormTextField
						disabled={formik.isSubmitting || isInitialLoading}
						autoComplete="off"
						label={'TOTP'}
						name={'code'}
						fullWidth
						focused
					/>
				</Grid>
				<Grid item container spacing={3}>
					{onDecline && (
						<Grid item xs={6}>
							<BackSubmitButton fullWidth type="button" variant="contained" color="secondary" onClick={onDecline}>
								Back
							</BackSubmitButton>
						</Grid>
					)}
					<Grid item xs={onDecline ? 6 : 12}>
						<SubmitButton disabled={!formik.isValid || formik.isSubmitting} label={'Verify'} />
					</Grid>
				</Grid>
			</Grid>
		</Form>
	);
};

export default TOTPForm;
